import { useTranslation } from 'react-i18next';
import CustomDataGridResult from '../../../../../../utils/Datagrid/CustomForecastDataGridResult';
import { customDataGridResultSimulation } from '../../../../../../utils/Datagrid/CustomForecastDataGridUtils';
import { translatePacCategory } from '../../Settings/Utils/SharedFunctions';

const DataGridCAPPoints = ({ rows, columns }) => {
  const { t } = useTranslation();

  const fourPointCategories = [
    t('simulation.result.pac.categories.winterCereals'),
    t('simulation.result.pac.categories.springCereals'),
    t('simulation.result.pac.categories.rootCrops'),
    t('simulation.result.pac.categories.winterOilseeds'),
    t('simulation.result.pac.categories.springOilseeds'),
  ];

  const processedColumns = columns?.slice(1)?.map((column, index) => {
    let processedColumn = {
      field: column,
      headerName: column,
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      flex: 1,
    };

    if (index === 0) {
      processedColumn = { ...processedColumn, cellClassName: 'previous-campain' };
    }

    return processedColumn;
  });

  const processedRows = rows?.map((row, index) => {
    const translatedCategory = translatePacCategory(row?.categorie, t);
    let processedRow = {
      id: row?.categorie + `-${index}`,
      hierarchy: fourPointCategories?.includes(translatedCategory)
        ? [t('simulation.result.pac.fourPointsCeiling'), translatedCategory]
        : [translatedCategory],
    };
    processedColumns?.map((column, idx) => {
      processedRow[column?.field] = row?.data?.[idx]?.value;
    });
    return processedRow;
  });

  const groupingColDef = {
    headerName: t('simulation.common.campaign'),
    field: 'group',
    headerAlign: 'center',
    hideDescendantCount: true,
    flex: 1,
    width: 250,
    minWidth: 250,
    maxWidth: 250,
  };

  const getTreeDataPath = (row) => row.hierarchy;
  const getRowClassName = (params) =>
    !fourPointCategories?.includes(params.id) ? 'classic-row Mui-even' : 'Mui-even';

  return (
    <div
      className="cap-points-categories-container"
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <h3>{t('simulation.result.common.pointsTitle')}</h3>
      <CustomDataGridResult
        rows={processedRows}
        columns={processedColumns}
        isLoading={false}
        getTreeDataPath={getTreeDataPath}
        groupingColDef={groupingColDef}
        treeData={true}
        theme={customDataGridResultSimulation}
        simulationContext={'simulation-box'}
        fullSize={true}
        fromCapPointsSimulation
        getRowClassName={getRowClassName}
      />
    </div>
  );
};

export default DataGridCAPPoints;
